import { initMainHeader } from '../js/src/header-init';
import { getQuoteFormInit } from "../js/src/get-quote-form";
import initCustomIntegration from "../js/src/custom-integration-common";
import '../scss/pages/intel-custom.scss';

initMainHeader();
getQuoteFormInit();

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomIntegration);
} else {
    initCustomIntegration();
}
